import { twMerge } from "tailwind-merge";
import { Icon } from "@sellar-io/components";

export const Chip = ({
  title,
  selected,
  onClick,
  value,
  selectable = true,
}: {
  title: string;
  value: string;
  selected: boolean;
  selectable?: boolean;
  onClick?: (value: string) => void;
}) => {
  return (
    <div
      className={twMerge(
        "w-fit overflow-hidden rounded-md border bg-zinc-100 stroke-zinc-300 px-4 py-2 text-base font-semibold text-zinc-600",
        selectable && "cursor-pointer hover:bg-zinc-200",
        selected &&
          "flex flex-row gap-2 bg-zinc-600 stroke-zinc-600 text-white hover:bg-zinc-700",
      )}
      onClick={() => onClick?.(value)}
    >
      {selected && <Icon icon={"CHECK"} />}
      <p>{title}</p>
    </div>
  );
};
